import "./styles.scss";
import React, { FC, useState, useEffect } from "react";
import HighlightCardMacro from "./HighlightCardMacro";
import { ICompanyProps } from "../../Types/Types";
import { useCompanyTags } from "queryHooks";
// import { useSelector } from "react-redux";
// import { IDefaultState } from "../../TrixtaComponents/store/reducers";

const CompanyHighLightCard: FC<ICompanyProps> = (props: ICompanyProps) => {
  const { company } = props;

  const [companyLocation, setCompanyLocation] = useState("");

  const { data: companyTags } = useCompanyTags({
    companyId: company.company_id,
  });

  const cardImageStyle = {
    backgroundSize: "100%",
    backgroundImage: `url(${company.card_header_image_url})`,
  };

  const cardColorStyle = {
    background: `#${company.primary_color}`,
  };

  let cardHeroStyle = company.card_header_image_url
    ? cardImageStyle
    : cardColorStyle;

  const invalid: string = "Unknown";

  let marketTags = companyTags
    ? companyTags.filter((tag) => tag.tag_type === "market_tag")
    : [];

  let businessModelTags = companyTags
    ? companyTags.filter((tag) => tag.tag_type === "business_model_tag")
    : [];

  let salesMotionTags = companyTags
    ? companyTags.filter((tag) => tag.tag_type === "sales_motion_tag")
    : [];

  let revenueStageTags = companyTags
    ? companyTags.filter((tag) => tag.tag_type === "revenue_stage_tag")
    : [];

  let productStageTags = companyTags
    ? companyTags.filter((tag) => tag.tag_type === "product_stage_tag")
    : [];

  let investmentRoundTags = companyTags
    ? companyTags.filter((tag) => tag.tag_type === "investment_round_tag")
    : [];

  // console.log("marketTags :>> ", marketTags);
  let createTagString = (tagArray) => {
    let string = "";
    tagArray.map((tag, index) => {
      const isLastIndex: boolean = tagArray.length == index + 1;
      string += `${tag["display_name"]}` + (isLastIndex ? "" : ", ");
    });

    return string;
  };

  useEffect(() => {
    let location = "";

    if (companyTags && companyTags.length) {
      let locationArray = [];

      let countryTag = companyTags.filter(
        (tag) => tag.tag_type === "country_tag"
      );

      if (countryTag.length) {
        //@ts-ignore
        locationArray.push(countryTag[0].display_name);
      }

      let stateTag = companyTags.filter((tag) => tag.tag_type === "state_tag");

      if (stateTag.length) {
        //@ts-ignore
        locationArray.push(stateTag[0].display_name);
      }

      let cityTag = companyTags.filter((tag) => tag.tag_type === "city_tag");

      if (cityTag.length) {
        //@ts-ignore
        locationArray.push(cityTag[0].display_name);
      }

      if (locationArray.length) {
        locationArray = locationArray.reverse();
        location = locationArray.join(", ");
      }
    }

    setCompanyLocation(location);
  }, [companyTags]);

  return (
    <div className="ps-company-detail-content__profile-highlight-card">
      <div
        className="ps-highlight-card__background-container"
        style={cardHeroStyle}
      />
      <div className="ps-company-detail-content__profile-highlight-card-inner">
        <HighlightCardMacro
          title={"Market Verticals"}
          tags={marketTags}
          fullText={invalid}
        />
        <HighlightCardMacro
          title={"Investment Stage"}
          fullText={
            createTagString(investmentRoundTags)
              ? createTagString(investmentRoundTags)
              : invalid
          }
        />

        <HighlightCardMacro
          title={"Business Model(s)"}
          fullText={
            createTagString(businessModelTags)
              ? createTagString(businessModelTags)
              : invalid
          }
        />

        <HighlightCardMacro
          title={"Sales Motion"}
          fullText={
            createTagString(salesMotionTags)
              ? createTagString(salesMotionTags)
              : invalid
          }
        />

        <HighlightCardMacro
          title={"Revenue Stage"}
          fullText={
            createTagString(revenueStageTags)
              ? createTagString(revenueStageTags)
              : invalid
          }
        />

        <HighlightCardMacro
          title={"Product Stage"}
          fullText={
            createTagString(productStageTags)
              ? createTagString(productStageTags)
              : invalid
          }
        />

        <HighlightCardMacro title={"Annual Revenue"} fullText={invalid} />

        <HighlightCardMacro
          title={"Location"}
          fullText={companyLocation ? companyLocation : invalid}
        />
        <HighlightCardMacro
          title={"Founded"}
          fullText={
            company && company["year_founded"]
              ? company["year_founded"]
              : (company && company["year_tag"]) ?? invalid
          }
        />
        <HighlightCardMacro
          title={"Website"}
          fullText={
            company && company["website_url"] ? company["website_url"] : invalid
          }
          url={company && company["website_url"]}
        />
      </div>
    </div>
  );
};

export default CompanyHighLightCard;
